import { createContext, useEffect, useState } from "react";
import { getServicesByInfluencer } from "../api/influencerApi";
import { getMyInfluencerAccountData, getMyCompanyAccountData, getPublicDataCompany, getPublicDataInfluencer } from "../api/myAccountApi";

import Alert from "../components/Alert/Alert";
import { FormattedMessage } from 'react-intl';

import { connect } from 'react-redux';
import { saveToken, deleteToken } from '../store/token/action';
import { useDispatch } from 'react-redux';


export const UserContext = createContext()

/* export default */function UserProvider({ children, saveToken }) {

    const dispatch = useDispatch();

    const [userToken, setUserToken] = useState(null);
    const [userType, setUserType] = useState('');

    const [id, setId] = useState(null);
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [companyId, setCompanyId] = useState(-1);
    const [companyName, setCompanyName] = useState('');

    const [imageProfile, setImageProfile] = useState('');
    const [videoProfile, setVideoProfile] = useState('');

    const [account, setAccount] = useState('');
    const [active, setActive] = useState(true);
    const [verified, setVerified] = useState(false);
    const [statusAccount, setStatusAccount] = useState('');
    const [uniqueName, setUniqueName] = useState('');
    const [auxUniqueName, setAuxUniqueName] = useState('');
    const [email, setEmail] = useState('');
    const [auxEmail, setAuxEmail] = useState('');
    const [secondEmail, setSecondEmail] = useState('');
    const [password, setPassword] = useState('');
    const [twoStepVerification, setTwoStepVerification] = useState(false);
    const [securityQuestion, setSecurityQuestion] = useState('');
    const [securityQuestionAnswer, setSecurityQuestionAnswer] = useState('');
    const [indicativePhone, setIndicativePhone] = useState('');
    const [phone, setPhone] = useState('');
    const [typeIdentification, setTypeIdentification] = useState('');
    const [identification, setIdentification] = useState('');
    const [gender, setGender] = useState('');
    const [birthday, setBirthday] = useState('');
    const [address, setAddress] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [payment, setPayment] = useState(false);
    const [colaborations, setColaborations] = useState(false);
    const [promotions, setPromotions] = useState(false);

    const [languages, setLanguages] = useState([]);
    const [categories, setCategories] = useState([]);
    const [categoriesNombre, setCategoriesNombre] = useState([]);
    const [description, setDescription] = useState(null);
    const [rating, setRating] = useState(null);
    const [city, setCity] = useState(null);
    const [country, setCountry] = useState({});

    const [products, setProducts] = useState([]);
    const [personalFare, setPersonalFare] = useState({});

    const [gallery, setGallery] = useState([]);

    const [youtubeSuscribers, setYoutubeSuscribers] = useState();
    const [twitterFollowers, setTwitterFollowers] = useState();
    const [facebookFollowers, setFacebookFollowers] = useState();
    const [instagramFollowers, setInstagramFollowers] = useState();
    const [tiktokFollowers, setTiktokFollowers] = useState();

    const [showAlertInvalidToken, setShowAlertInvalidToken] = useState(false);

    const [collaborators, setCollaborators] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem('fluincrToken');
        if (token === null) {
            const tokenSession = sessionStorage.getItem('fluincrToken');
            if (tokenSession !== null) {
                setUserToken(JSON.parse(tokenSession));
                dispatch(saveToken(JSON.parse(tokenSession)))
            } else {
                dispatch(deleteToken())
            }
        } else {
            setUserToken(JSON.parse(token));
            dispatch(saveToken(JSON.parse(token)))
        }


        const type = localStorage.getItem('fluincrUser');
        if (type === null) {
            const typeSession = sessionStorage.getItem('fluincrUser');
            if (typeSession !== null) {
                setUserType(JSON.parse(typeSession));
            }
        } else {
            setUserType(JSON.parse(type));
        }


    }, [])


    useEffect(() => {

        if (userToken !== null) {

            if (userType === 'influencer') {
                console.log("😎", userToken)
                getMyInfluencerAccountData({ token: userToken }).then((response) => {

                    console.log(response)
                    if (response.status === 403) {
                        sessionStorage.removeItem('fluincrToken');
                        localStorage.removeItem('fluincrToken');
                        sessionStorage.removeItem('fluincrUser');
                        localStorage.removeItem('fluincrUser');
                        sessionStorage.removeItem('isAdmin');
                        dispatch(deleteToken());
                        setUserToken(null);
                        setUserType('');
                        setShowAlertInvalidToken(true);
                    } else {
                        setId(response.id);
                        setName(response.givenName);
                        setLastName(response.familyName);
                        setAccount(response.account);
                        setActive(response.attributes?.active);
                        setVerified(response.attributes?.verified);
                        setStatusAccount(response.attributes?.status);
                        setUniqueName(response.username);
                        //setAuxUniqueName(response.username?.split('/')[1]);
                        setAuxUniqueName(response.username);
                        setEmail(response.mail);
                        setAuxEmail(response.mail);
                        setSecondEmail(response.secondMail);
                        setPassword(response.password);
                        setTwoStepVerification(response.attributes?.twoStepVerification);
                        setSecurityQuestion({ name: response.attributes?.securityQuestion, nombre: response.attributes.preguntaSeguridad });
                        setSecurityQuestionAnswer(response.attributes?.securityAnswer);
                        setIndicativePhone(response.indicative);
                        setPhone(response.phoneNumber);
                        setTypeIdentification(response.attributes?.typeId);
                        setIdentification(response.attributes?.numberId);
                        setGender(response.gender);
                        setBirthday(response.birthday);
                        setAddress(response.address);
                        setZipCode(response.attributes.zipcode);
                        setPayment(response.attributes.paypal);
                        setColaborations(response.notification?.colaborations);
                        setPromotions(response.notification?.promotions);

                        setCity(response.city);
                        setCountry(response.country);

                        //Ya no llega
                        //setPersonalFare(response.personalFare);
                        setRating(response.rating);

                        setImageProfile(response.imageProfile);
                        setVideoProfile(response.videoProfile);

                        if (response.gallery !== null) {
                            setGallery(response.gallery);
                        }

                        setTiktokFollowers(response.followers.tiktok);
                        setTwitterFollowers(response.followers.twitter)
                        setYoutubeSuscribers(response.followers.youtube)
                        setFacebookFollowers(response.followers.facebook)
                        setInstagramFollowers(response.followers.instagram)

                        getServicesByInfluencer({ influencerId: response.id }).then((responseService) => {
                            setPersonalFare(responseService);
                        })

                        if (response.attributes.collaborators) {
                            setCollaborators(response.attributes?.collaborators)
                        }
                    }

                })

            } else if (userType === 'company') {
                console.log("😎", userToken)
                getMyCompanyAccountData({ token: userToken }).then((response) => {
                    console.log(response);
                    if (response.status === 403) {
                        sessionStorage.removeItem('fluincrToken');
                        localStorage.removeItem('fluincrToken');
                        sessionStorage.removeItem('fluincrUser');
                        localStorage.removeItem('fluincrUser');
                        sessionStorage.removeItem('isAdmin');
                        dispatch(deleteToken());
                        setUserToken(null);
                        setUserType('');
                        setShowAlertInvalidToken(true);
                    } else {
                        setId(response.id);
                        setCompanyId(response.id);
                        setCompanyName(response.nameCompany);
                        setAccount(response.account);
                        setActive(response.attributes.active);
                        setVerified(response.attributes.verified);
                        setStatusAccount(response.attributes.status);
                        setUniqueName(response.username);
                        //setAuxUniqueName(response.username.split('/')[1]);
                        setAuxUniqueName(response.username);
                        setEmail(response.mail);
                        setAuxEmail(response.mail);
                        setSecondEmail(response.secondMail);
                        setPassword(response.password);
                        setTwoStepVerification(response.attributes.twoStepVerification);
                        setSecurityQuestion({ name: response.attributes.securityQuestion, nombre: response.attributes.preguntaSeguridad });
                        setSecurityQuestionAnswer(response.attributes.securityAnswer);
                        setIndicativePhone(response.indicative);
                        setPhone(response.phoneNumber);
                        setTypeIdentification(response.attributes.typeId);
                        setIdentification(response.attributes.numberId);
                        setGender(response.gender);
                        setBirthday(response.birthday);
                        setAddress(response.address);
                        setZipCode(response.attributes.zipcode);
                        setPayment(response.attributes.paypal);
                        setColaborations(response.notification.colaborations);
                        setPromotions(response.notification.promotions);

                        setCity(response.city);
                        setCountry(response.country);

                        setRating(response.rating);

                        setProducts(response.product);

                        setImageProfile(response.imageProfile);
                        setVideoProfile(response.videoProfile);

                        setTiktokFollowers(response.followers.tiktok);
                        setTwitterFollowers(response.followers.twitter)
                        setYoutubeSuscribers(response.followers.youtube)
                        setFacebookFollowers(response.followers.facebook)
                        setInstagramFollowers(response.followers.instagram)
                    }
                })
            }

        }
    }, [userToken])

    return (
        <UserContext.Provider value={{ userToken, setUserToken, userType, setUserType, id, setId, name, setName, lastName, setLastName, companyId, setCompanyId, companyName, setCompanyName, imageProfile, setImageProfile, account, setAccount, active, setActive, verified, setVerified, statusAccount, setStatusAccount, uniqueName, setUniqueName, auxUniqueName, setAuxUniqueName, email, setEmail, auxEmail, setAuxEmail, secondEmail, setSecondEmail, password, setPassword, twoStepVerification, setTwoStepVerification, securityQuestion, setSecurityQuestion, securityQuestionAnswer, setSecurityQuestionAnswer, indicativePhone, setIndicativePhone, phone, setPhone, typeIdentification, setTypeIdentification, identification, setIdentification, gender, setGender, birthday, setBirthday, address, setAddress, zipCode, setZipCode, payment, setPayment, promotions, setPromotions, colaborations, setColaborations, languages, setLanguages, categories, setCategories, categoriesNombre, setCategoriesNombre, description, setDescription, rating, setRating, city, setCity, country, setCountry, products, setProducts, personalFare, setPersonalFare, videoProfile, setVideoProfile, gallery, setGallery, tiktokFollowers, setTiktokFollowers, twitterFollowers, setTwitterFollowers, youtubeSuscribers, setYoutubeSuscribers, facebookFollowers, setFacebookFollowers, instagramFollowers, setInstagramFollowers, collaborators, setCollaborators }}>
            {children}
            {(showAlertInvalidToken) && (<Alert
                title={<FormattedMessage id="invalid_user_title" defaultMessage="Usuario invalido" />}
                text={<FormattedMessage id="invalid_user_text" defaultMessage="Por favor verifique e intente de nuevo" />}
                setShowAlert={setShowAlertInvalidToken}
            />)}
        </UserContext.Provider>
    )

}


const mapStateToProps = (state) => {
    return {
        token: state.tokenReducer.token
    }
}

const mapDispatchToProps = {
    saveToken,
    deleteToken
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProvider)